import http from "./http-common";
class FaqDataService {
  getAll(offset, limit) {
    return http.get(`/get-data-faq?offset=${offset}&limit=${limit}`);
  }
}
export default new FaqDataService();